/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React from 'react';
import { SkipLinksProps } from './SkipLinks.props';

/**
 * SDS SkipLinks component.
 */
export const SkipLinks = (props: SkipLinksProps): JSX.Element => {
  const { classes, linkList, ...rest } = props;
  const skipClass = clsx(`sds-skip-links`, classes);

  const getLinks = (): Array<JSX.Element> => {
    const links = linkList || [];
    return links.map((link): JSX.Element => {
      return (
        <li key={link.key}>
          <button className="sds-skip-links__button sr-only sr-reveal" onClick={(): void => skipTo(link.targetId)}>
            {link.label}
          </button>
        </li>
      );
    });
  };

  return (
    <div className={skipClass} {...rest}>
      <ul className="sds-skip-links__list">{getLinks()}</ul>
    </div>
  );
};

/**
 * Skip links click handler to shift keyboard focus to a new element.
 * @param {string} elementID The target element to focus on.
 */
const skipTo = (elementID: string): void => {
  const current = document.activeElement as HTMLElement;
  const target = document.querySelector(`#${elementID}`) as HTMLElement;

  current.blur();
  target.focus();
};
